module.exports = __webpack_public_path__ + "img/truck.5d861336.png";